import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  selectCheck() {
    this.ticketSelect();
  }

  //モーダル表示
  ticketSelect() {
    let hasValue = false;
    let $lottery_ticket_cards = $('.ticket-card[data-restricted="false"][data-sales_type="lottery"]');
    let $normal_ticket_cards = $(
      '.ticket-card[data-restricted="false"][data-sales_type="normal"][data-application_limited="true"]',
    );

    // １以上の値が選択されたかどうかチェック
    $(".js-ticket-select").each(function () {
      $(this)
        .find("option:selected")
        .each(function () {
          if ($(this).val() >= 1) {
            hasValue = true;
            // 抽選チケットの場合、SelectBoxのDisableを制御
            let $outer = $(this);
            $lottery_ticket_cards.each(function () {
              if (!$(this).is($outer.parents(".ticket-card"))) {
                $(this).addClass("is-disabled");
                $(this).find("select").prop("disabled", true);
              }
            });
            // 先着チケットかつ、受付単位の申込回数制限がある場合、SelectBoxのDisableを制御
            $normal_ticket_cards.each(function () {
              if (!$(this).is($outer.parents(".ticket-card"))) {
                $(this).addClass("is-disabled");
                $(this).find("select").prop("disabled", true);
              }
            });
          }
        });
    });

    // ボタン非活性制御
    if (hasValue) {
      $(".js-ticket-submit-button").attr("aria-disabled", false);
    } else {
      $(".js-ticket-submit-button").attr("aria-disabled", true);
      // 購入制限が入っていないすべてのセレクトBOXを有効化
      $lottery_ticket_cards.removeClass("is-disabled");
      $lottery_ticket_cards.find("select").prop("disabled", false);
      $normal_ticket_cards.removeClass("is-disabled");
      $normal_ticket_cards.find("select").prop("disabled", false);
    }
  }
}
